import { render, staticRenderFns } from "./labresults.vue?vue&type=template&id=f287993a"
import script from "./labresults.vue?vue&type=script&lang=js"
export * from "./labresults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports